exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".basic-info-disability form{padding:0 !important}.basic-info-disability form .form-fields{padding:1rem 1rem 2rem}@media(max-width: 575px){.basic-info-disability form .form-fields{padding:15px}}.basic-info-disability form .form-fields .descr{font-size:.8rem;line-height:1.25;color:#343a40}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Disability/steps/BasicInfo.scss
// module id = 7755
// module chunks = 13